import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import ImpersonationBanner from '../ImpersonationBanner';

const Layout = () => {
    const isImpersonating = !!localStorage.getItem('impersonatorToken');

    return (
        <div className="min-h-screen bg-gray-50">
            <ImpersonationBanner />
            <div className="flex">
                <Sidebar />
                <div className="flex-1 ml-64">
                    <main className={`p-6 ${isImpersonating ? 'mt-[40px]' : 'mt-0'}`}>
                        <Outlet />
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Layout;
